// 2026-04 域名路径调整：
// 前端页面主路径从 `/claw` 切到 `/mainagent`。
// 这里只保留旧 `/claw` 到 `/mainagent` 的兼容映射`。
export const LEGACY_CLAW_ROUTE_BASE = '/claw';
export const MAINAGENT_ROUTE_BASE = '/mainagent';
export const MAINAGENT_DASHBOARD_PATH = `${MAINAGENT_ROUTE_BASE}/dashboard`;
export const MAINAGENT_CHAT_PATH = `${MAINAGENT_ROUTE_BASE}/chat`;
export const MAINAGENT_WORKBENCH_PATH = `${MAINAGENT_ROUTE_BASE}/workbench`;

export function isPathUnderBase(pathname: string, base: string) {
  return pathname === base || pathname.startsWith(`${base}/`);
}

export function isMainagentPath(pathname: string) {
  return isPathUnderBase(pathname, MAINAGENT_ROUTE_BASE);
}

export function buildMainagentPath(sessionKey?: string | null) {
  return sessionKey
    ? `${MAINAGENT_ROUTE_BASE}/${sessionKey}`
    : MAINAGENT_ROUTE_BASE;
}

// 仅做旧页面路由兼容，后端接口前缀 `/claw/api`、`/claw/ops/api` 不在这里处理。
export function normalizeLegacyClawPath(pathname: string) {
  if (pathname === LEGACY_CLAW_ROUTE_BASE) {
    return MAINAGENT_ROUTE_BASE;
  }

  if (pathname.startsWith(`${LEGACY_CLAW_ROUTE_BASE}/`)) {
    return `${MAINAGENT_ROUTE_BASE}${pathname.slice(LEGACY_CLAW_ROUTE_BASE.length)}`;
  }

  return pathname;
}
